module.exports = __webpack_public_path__ + "assets/d1d9c5a8d44a6bed966f21802be5d9d1.svg";